import { render, staticRenderFns } from "./custom-modal.vue?vue&type=template&id=2260a272&scoped=true&"
import script from "./custom-modal.vue?vue&type=script&lang=js&"
export * from "./custom-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2260a272",
  null
  
)

export default component.exports